import "./App.css";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import CoreFeatures from "./components/CoreFeatures/CoreFeatures";
import WorkflowSection from "./components/WorkflowSection/WorkflowSection";
import WhyTecnivorns from "./components/WhyTecnivorns/WhyTecnivorns";
import ProductModules from "./components/ProductModules/ProductModules";
import FinalCTA from "./components/FinalCTA/FinalCTA";
import Footer from "./components/Footer/Footer";
import { useState } from "react";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";

const HomePage = () => {
  const [isSignupOpen, setIsSignupOpen] = useState(false);

  return (
    <div>
      <Navbar openSignupOnMount={isSignupOpen} />{" "}
      <main>
        <Hero />
        <CoreFeatures />
        <WorkflowSection />
        <WhyTecnivorns />
        <ProductModules />
        <FinalCTA />
      </main>
      <Footer
        onOpenSignup={() => {
          setIsSignupOpen(false);
          setTimeout(() => setIsSignupOpen(true), 0);
        }}
      />{" "}
    </div>
  );
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/tecnvirons-website/privacy-policy"
        element={<PrivacyPolicy />}
      />
      <Route
        path="/tecnvirons-website/terms-of-service"
        element={<TermsOfService />}
      />
      <Route
        path="/tecnvirons-website/cookie-policy"
        element={<CookiePolicy />}
      />
    </Routes>
  );
}

export default App;
